module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-588.38072dc.woff2";